import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  SoftwareAndSaasDevelopmentIcon,
  WebsiteAndAppDevelopmentIcon,
  cloudAndDevops,
  cyberSecurity,
  itSupportAndMaintainance,
} from "../../../../assets/icons/serviceIcon/index";
import MobileAppDevelopmentWork from "./MobileAppDevelopmentWork";

const items = [
  {
    name: "Native App Development",
    text: "We build native apps that blend seamlessly with iOS and Android, delivering a smooth, intuitive experience that keeps users engaged from the very first tap.",
  },
  {
    name: "Cross-Platform App Development",
    text: "Why build two apps when one does it all? We create cross-platform apps that work seamlessly on iOS and Android, saving you time, cost, and effort without compromising performance.",
  },
  {
    name: "Hybrid App Development",
    text: "Somewhere between web and mobile lies the perfect balance. Hybrid apps give you the flexibility to work across platforms while keeping everything fast, responsive, and user-friendly.",
  },
];

const otherService = [
  {
    icon: WebsiteAndAppDevelopmentIcon,
    name: "Website & App Development",
    des: "We build websites that tell stories, connect hearts and build brands.",
    path: "/web-app-development",
  },
  {
    icon: cloudAndDevops,
    name: "Cloud & DevOps Solutions",
    des: "No tech headaches - just fast, secure, and hassle-free cloud solutions.",
    path: "/cloud-devops-development",
  },
  {
    icon: SoftwareAndSaasDevelopmentIcon,
    name: "Software & SaaS Development",
    des: "Smart, scalable, and built for the long run - software that grows with you.",
    path: "/software-saas-development",
  },
  {
    icon: cyberSecurity,
    name: "Cybersecurity & Data Protection",
    des: "Your data stays yours! We lock it down so hackers don’t stand a chance.",
    path: "/cybersecurity-data-protection",
  },
  {
    icon: itSupportAndMaintainance,
    name: "IT Support & Maintenance",
    des: "Seamless IT services to protect and power your business growth.",
    path: "/it-support-maintenance",
  },
];

const MobileAndAppDevelopment = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Development"
        description="Your business needs an app that works just as hard as you do. We build mobile apps that engage users, boost sales and keep them coming back for more."
        heading="Mobile & App"
      />
      <NewCommonServiceForm title="Mobile & App Development" items={items} />
      <MobileAppDevelopmentWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default MobileAndAppDevelopment;
